import { render } from "./MapComponentLegend.vue?vue&type=template&id=53755ff6&scoped=true"
import script from "./MapComponentLegend.vue?vue&type=script&lang=js"
export * from "./MapComponentLegend.vue?vue&type=script&lang=js"

import "./MapComponentLegend.vue?vue&type=style&index=0&id=53755ff6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mapalytics-frontend/mapalytics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53755ff6"]])

export default __exports__